import styles from './product-card-skeleton.module.css';
import { getSkeletonRandom, Skeleton } from '../../skeleton/skeleton.component';
import { memo } from 'react';

type SkeletonProps = {
    className?: string;
};

export const ProductCardSkeleton = memo((props: SkeletonProps) => {
    const firstLineWidth = getSkeletonRandom(100);
    const secondLineWidth = getSkeletonRandom(50);
    const thirdLineWidth = getSkeletonRandom(30);

    const { className } = props;
    return (
        <div className={className}>
            <Skeleton width="100%" aspectRatio="1 / 1.49" />

            <div className={styles.details}>
                <Skeleton width={`${firstLineWidth}%`} height="14px" />
                <Skeleton width={`${secondLineWidth}%`} height="12px" />
                <Skeleton width={`${thirdLineWidth}%`} height="12px" />
                <div className={styles.tags}>
                    <Skeleton width="40%" height="12px" />
                    <Skeleton width="40%" height="12px" />
                </div>
            </div>
        </div>
    );
});
